import React from 'react'
import './toggle.css';

const Toggle = ({
    label = "Label",
    name = "name",
    className = "",
    readonly = false,
    checked = false,
    onChange = null,
}) => {
    const handleChange = event => {
        if (readonly) {
            return;
        }

        const _isChecked = event.target.checked;
        if (onChange != null) {
            onChange(_isChecked);
        }
    }

    return (
        <label
            className={`bon-toggle ${className}`}
        >
            <span className="switch-root">
                <input
                    type="checkbox"
                    name={name}
                    checked={checked}
                    onChange={handleChange}
                    readOnly={readonly}
                />
                <span className="track-root">
                    <span className="track" />
                    <span className="circle" />
                </span>
            </span>
            <span className="label">{label}</span>
        </label>
    )
}

export default Toggle;